export default "__VITE_ASSET__CWFQyZup__"